export default __webpack_public_path__ + "static/3-8dfc3d943524b266adc6cfeba0b312ce.png";